import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=cbfd9d3a&lang=pug"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbfd9d3a')) {
      api.createRecord('cbfd9d3a', component.options)
    } else {
      api.reload('cbfd9d3a', component.options)
    }
    module.hot.accept("./ProductPrice.vue?vue&type=template&id=cbfd9d3a&lang=pug", function () {
      api.rerender('cbfd9d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductPrice.vue"
export default component.exports